import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getTestIds } from 'seagull/utils/TestIds';
import { defaultAuthorizedRoute, routes } from '~/constants';
import { useStore } from '~/contexts';
import { useIntercomStarter } from '~/intercom/IntercomStarter';
import { useOptimizedMobileViewport } from '~/providers/MobileViewportWidthProvider';
import { selectors } from '~/store/state-selectors';
import { markRouteChunkLoaded } from '~/utils/routeConfigs';
import { MobileDeviceEnhancer } from './MobileDeviceEnhancer/MobileDeviceEnhancer';
export const GetRouteWrapperTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            RouteWrapperTID: {
                BlockedPartiallyOnboardedVendor: 'blocked-partially-onboarded-vendor'
            }
        }
    });
function useEnableIntercom(enableIntercom) {
    const { setEnableIntercom } = useIntercomStarter();
    useEffect(()=>{
        setEnableIntercom(enableIntercom);
    }, [
        enableIntercom
    ]);
}
export function RouteWrapper(param) {
    let { config } = param;
    const { component: Component, supportsMobileViewport = false, supportsMobileDevice = false, allowPartiallyOnboardedVendor = false, deniedToRoles, enableIntercom } = config;
    const { RouteWrapperTID } = useMemo(()=>GetRouteWrapperTID(), []);
    useOptimizedMobileViewport(supportsMobileViewport);
    useEnableIntercom(enableIntercom);
    const location = useLocation();
    const businessId = useStore(selectors.user.businessId);
    const userId = useStore(selectors.user.id);
    const role = useStore(selectors.user.role);
    const isDeniedForRole = role != null && !!(deniedToRoles === null || deniedToRoles === void 0 ? void 0 : deniedToRoles.includes(role));
    const isPartiallyOnboardedVendor = !!userId && !businessId;
    const shouldBlock = !allowPartiallyOnboardedVendor && isPartiallyOnboardedVendor;
    const defaultRouteForVendor = defaultAuthorizedRoute(true);
    const rendersRoutedPage = !isDeniedForRole && !shouldBlock;
    useEffect(()=>{
        if (rendersRoutedPage) {
            markRouteChunkLoaded(config.url);
        }
    }, [
        config.url,
        rendersRoutedPage
    ]);
    if (isDeniedForRole) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: routes.noAccessPage,
            replace: true
        });
    }
    if (shouldBlock) {
        return location.pathname === defaultRouteForVendor ? /*#__PURE__*/ _jsx("div", {
            "data-testid": RouteWrapperTID.BlockedPartiallyOnboardedVendor()
        }) : /*#__PURE__*/ _jsx(Navigate, {
            to: {
                pathname: defaultRouteForVendor,
                search: location.search
            },
            replace: true
        });
    }
    const element = /*#__PURE__*/ _jsx(Component, {});
    if (supportsMobileDevice) {
        return /*#__PURE__*/ _jsx(MobileDeviceEnhancer, {
            children: element
        });
    }
    return element;
}
